import Dashboard from "views/panel/dashboard/Dashboard";
// import Timesheet from "views/panel/timesheet/Timesheet";
import Profile from "views/panel/profile/Profile";
import ChangePassword from "views/panel/profile/ChangePassword";
import TrainingStatus from "views/panel/trainingStatus/TrainingStatus";
import ViewLeave from "views/panel/leave/ViewLeave";
import aprovalLeave from "views/panel/leave/aprovalLeave";
import leavetypes from "views/panel/leave/leaveTypes";
import holidaylist from "views/panel/leave/holidaysList";
import employeelist from "views/panel/employee/employee"
import ManageMyTeam from "views/panel/manageMyTeam/ManageMyTeam"
import project from "views/panel/Project/ProjectSetup"
import RolesSetup from "views/panel/projectrole/RolesSetup"
import TaskSetup from "views/panel/projecttask/TaskSetup"

import EmployeeRoster from "views/panel/employeeRoster/EmployeeRoster";
import AddEmployee from "views/panel/addEmployee/AddEmployee";
import contactInfo from "views/panel/addEmployee/ContactInfo";
import educationInfo from "views/panel/addEmployee/EducationInfo";
import ContactInfo from "views/panel/addEmployee/ContactInfo";
import EducationInfo from "views/panel/addEmployee/EducationInfo";
import Timesheetsummary from "views/panel/employeeRoster/timesheetsummary";
import EditEmployee from "views/panel/editEmployee/EditEmployee"
import EditContactInfo from "views/panel/editEmployee/EditContactInfo";
import EditEducationInfo from "views/panel/editEmployee/EditEducationInfo";
import MainInfo from "views/panel/addEmployee/MainInfo";
import ConfigurationPage from "views/panel/ConfigurationPage/configurationPage";
import TitlePage from "views/panel/ConfigurationPage/TitlePage";
import Gender from "views/panel/ConfigurationPage/Gender";
import Holidays from "views/panel/ConfigurationPage/Holidays"
import Country from "views/panel/ConfigurationPage/Country";
import Certificate from "views/panel/ConfigurationPage/Certificate";
import Document from "views/panel/ConfigurationPage/Document";
import Roles from "views/panel/ConfigurationPage/Roles";
import EmploymentType from "views/panel/ConfigurationPage/EmploymentType";
import WorkLocation from "views/panel/ConfigurationPage/WorkLocation";
import YearsOFExperience from "views/panel/ConfigurationPage/YearsOfExperience";
import States from "views/panel/ConfigurationPage/States";
import Cities from "views/panel/ConfigurationPage/Cities";
import Degree from "views/panel/ConfigurationPage/Degree";
import BloodGroup from "views/panel/ConfigurationPage/BloodGroup";
import MaritalStatus from "views/panel/ConfigurationPage/MaritalStatus";
import Designations from "views/panel/ConfigurationPage/Designations";
import Relationship from "views/panel/ConfigurationPage/Relationship";
import Departments from "views/panel/ConfigurationPage/Departments";
import Banks from "views/panel/ConfigurationPage/Bank";
import BankBranches from "views/panel/ConfigurationPage/BankBranches"
import AddNewProject from "views/panel/Project/AddNewProject";
import AddNewRole from "views/panel/projectrole/AddNewRole";
import AddNewTask from "views/panel/projecttask/AddNewTask";
import EditNewProject from "views/panel/Project/EditNewProject";
import EditNewRole from "views/panel/projectrole/EditNewRole";
import EditNewTask from "views/panel/projecttask/EditNewTask";
import Timesheet from "views/panel/timesheetnew/Timesheet";
import projectType from "views/panel/ConfigurationPage/Project";
import Reports from "views/panel/reports/Reports";
import Settings from "views/panel/ConfigurationPage/Settings";
import Permissions from "views/panel/ConfigurationPage/Permissions";
import WeeklyReport from "views/panel/reports/Weeklreport/WeeklyReport";
import LeaveDashboard from "views/panel/LeaveManagement/LeaveDashboard";
import LeaveApply from "views/panel/LeaveManagement/LeaveApply/LeaveApply";
import TimesheetTaskTable from "views/panel/timesheetnew/TimesheetTaskTable";
import LeaveMain from "views/panel/LeaveManagement/LeaveMain";
import LeaveHistory from "views/panel/LeaveManagement/LeaveHistory/LeaveHistory";
import TimesheetSummaryView from "views/panel/reports/TimesheetSummaryReports/TImesheetSummaryView";
import ManagerLeaveHistory from "views/panel/LeaveManagement/managerView/ManagerLeaveHistory";
import ImportQualityData from "views/panel/vraShifts/ImportQualityData/ImportQualityData";
import QualityDashboard from "views/panel/vraShifts/QualityDashboard/qualityDashboard";
import QualityDetails from "views/panel/vraShifts/QualityDashboard/qualityDetails"
import QualitySettings from "views/panel/vraShifts/QualityDashboard/QualitySettings";

// import rpMasterTable from "views/panel/rpMasterTable/rpMasterTable";
// import VraShifts from "views/panel/vraShifts/vraShifsMain/VraShifts";
// import AddVraShifts from "views/panel/vraShifts/AddVraShifts/AddVraShifts";
import RpHomePage from "views/panel/vraShifts/homePage/RpHomePage";
// import VraEdit from "views/panel/vraShifts/vraShifsMain/vraEdit";
// import TrainingSetupm from "views/panel/vraShifts/trainingSetup/TrainingSetup";
import TrainingSetup from "views/panel/vraShifts/trainingSetup/TrainingSetup";
import ImportSrf from "views/panel/vraShifts/ImportSrf/importsrf";
import RPreports from "views/panel/vraShifts/reports/RPreports";
import AddTrainee from "views/panel/vraShifts/trainingSetup/AddTrainee";
import VraRoster from "views/panel/vraShifts/vraRoster/VraRoster";
import RadRoster from "views/panel/vraShifts/radRoster/RadRoster";
import AddRadRoster from "views/panel/vraShifts/radRoster/AddRadRoster";
import ImportQagenda from "views/panel/vraShifts/ImportQagnda/ImportQagenda";
import RadScheduleForecast from "views/panel/vraShifts/reports/RadScheduleForecast";
import RadScheduleActual from "views/panel/vraShifts/reports/RadScheduleActual";
import AddVraRoster from "views/panel/vraShifts/vraRoster/AddVraRoster";
import VraRadAffinity from "views/panel/vraShifts/vraRadAffinity/VraRadAffinity";
import RadRosterReport from "views/panel/vraShifts/reports/RadRosterReport";
import VraRosterReport from "views/panel/vraShifts/reports/VraRosterReport";
import AddVraRadAffinity from "views/panel/vraShifts/vraRadAffinity/AddVraRadAffinity";
import RadScheduleForecastCalenderView from "views/panel/vraShifts/reports/RadScheduleForecastCalenderView";
import VraSubstitutions from "views/panel/vraShifts/VraSubstitutions/VraSubstitutions";
import VraSubstitutionEmailTemplate from "views/panel/vraShifts/EmailTemplates/VraSubstitutionEmailTemplate"
import VraSubstitutionHistory from "views/panel/vraShifts/VraSubstitutions/VraSubstitutionHistory";
import VraMonthlyScheduleForecastCalendar from "views/panel/vraShifts/reports/VraMonthlyScheduleForecastCalendar";
import VraScheduling from "views/panel/vraShifts/VraScheduling/VraScheduling";
import Settingss from "views/panel/vraShifts/Settings/Settingss";
import AddAffinity from "views/panel/vraShifts/VraScheduling/AddAffinity";
import EmployeeInfoReport from "views/panel/reports/EmployeeRoster/EmployeeInfoReport";
import ManagerView from "views/panel/PerformanceManagement/ManagerView/ManagerView";
import EmployeeView from "views/panel/PerformanceManagement/EmployeeView/EmployeeView";

// import Performance from "views/panel/Performance Management/HR View";
import HRview from "views/panel/PerformanceManagement/HRView/HRview";
import HRReport from "views/panel/PerformanceManagement/HRView/HRReport";
import ManagerReport from "views/panel/PerformanceManagement/ManagerView/ManagerReport";
import ImportVraShifts from "views/panel/vraShifts/importVraShifts/ImportVraShifts"
import ExitManagement from "views/panel/ExitManagement/ExitManagement"
import ExitManagementManager from "views/panel/ExitManagement/ExitManagementManager";
import EMS_Admin from "views/panel/ExitManagement/EMS_Admin";
import EMS_IT from "views/panel/ExitManagement/EMS_IT";
import EMS_Finance from "views/panel/ExitManagement/EMS_Finance";
import ExitManagement_final from "views/panel/ExitManagement/ExitManagementFinal";
import VraRadPool from "views/panel/vraShifts/vraRadPool/VraRadPool";


import RpShiftTimingsConfig from "views/panel/vraShifts/RpShiftTimings/RpShiftTimingsConfig";
import Attendance from "views/panel/Attendance/Attendance";
import AttendanceManager from "views/panel/Attendance/AttendanceManager";
import PoolPrepRoster from "views/panel/vraShifts/poolPrepRoster/PoolPrepRoster";
import AddPoolPrepRoster from "views/panel/vraShifts/poolPrepRoster/AddPoolPrepRoster";
import EditPoolPrepRoster from "views/panel/vraShifts/poolPrepRoster/EditPoolPrepRoster";
import AtcRoster from "views/panel/vraShifts/atcRoster/AtcRoster";
import AddAtcRoster from "views/panel/vraShifts/atcRoster/AddAtcRoster";
import EditAtcRoster from "views/panel/vraShifts/atcRoster/EditAtcRoster";
import ProbationManagement from "views/panel/ProbationManagement/ProbationManagement"

var childRoutes = [
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   component: Dashboard,
  //   permissionName: "VIEW_DASHBOARD",
  // },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    permissionName: "VIEW_PROFILE",
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    permissionName: "VIEW_PROFILE",
  },
  {
    path: "/change_password",
    name: "Change Password",
    component: ChangePassword,
    permissionName: "VIEW_PROFILE",
  },
  {
    path: "/employeeList",
    name: "Employee List",
    component: employeelist,
    permissionName: "VIEW_EMPLOYEE",
  },
  {
    path: "/Employeeinformation",
    name: "Employee Information",
    component: EmployeeRoster,
    permissionName: "VIEW_EMPLOYEE"  
  },
  {
    path: "/timesheetsummary",
    name: "timesheetsummary",
    component: Timesheet,
    permissionName: "VIEW_TIMESHEET"  
  },
  {
    path: "/addEmployee",
    name: "addEmployee",
    component: EmployeeRoster,
    permissionName: "VIEW_EMPLOYEE"  
  },
  {
    path: "/contactInfo",
    name: "contactInfo",
    component: ContactInfo,
    permissionName: "VIEW_ADMIN"  
  },
  {
    path: "/educationInfo",
    name: "educationInfo",
    component: EducationInfo,
    permissionName: "VIEW_ADMIN"  
  },
  {
    path: "/editEmployee/:id",
    name: "editEmployee",
    component: EditEmployee,
    permissionName: "VIEW_EMPLOYEE"
  },
  {
    path: "/editContactInfo",
    name: "editContactInfo",
    component: EditContactInfo,
    permissionName: "VIEW_EMPLOYEE"
  },
  {
    path: "/EditEducationInfo",
    name: "EditEducationInfo",
    component: EditEducationInfo,
    permissionName: "VIEW_EMPLOYEE"
  },
  {
    path: "/mainInfo",
    name: "mainInfo",
    component: MainInfo,
    permissionName: "VIEW_EMPLOYEE"
  },
  {
    path: "/configurationPage",
    name: "configurationPage",
    component: ConfigurationPage,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/TitlePage",
    name: "TitlePage",
    component: TitlePage,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Gender",
    name: "Gender",
    component: Gender,
    permissionName: "VIEW_CONFIG"
  },
   
  {
    path: "/Holidays",
    name: "Holidays",
    component: Holidays,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Country",
    name: "Country",
    component: Country,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Certificate",
    name: "Certificate",
    component: Certificate,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Document",
    name: "Document",
    component: Document,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Roles",
    name: "Roles",
    component: Roles,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/EmploymentType",
    name: "EmploymentType",
    component: EmploymentType,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/WorkLocation",
    name: "WorkLocation",
    component: WorkLocation,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/YearsOFExperience",
    name: "YearsOFExperience",
    component: YearsOFExperience,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/States",
    name: "States",
    component: States,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Cities",
    name: "Cities",
    component: Cities,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Degree",
    name: "Degree",
    component: Degree,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/BloodGroup",
    name: "BloodGroup",
    component: BloodGroup,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/MaritalStatus",
    name: "MaritalStatus",
    component: MaritalStatus,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Designations",
    name: "Designations",
    component: Designations,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Relationship",
    name: "Relationship",
    component: Relationship,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Departments",
    name: "Departments",
    component: Departments,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Banks",
    name: "Banks",
    component: Banks,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/BankBranches",
    name: "BankBranches",
    component: BankBranches,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/projectType",
    name: "projectType",
    component: projectType,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/project",
    name: "project",
    component: project,
    permissionName: "VIEW_PROJECT"  
  },
  {
    path: "/AddProject",
    name: "AddProject",
    component: AddNewProject,
    permissionName: "VIEW_PROJECT"
  },
  {
    path: "/EditProjectTask/:id",
    name: "EditProjectTask",
    component: EditNewProject,
    permissionName: "VIEW_PROJECT"
  },
  {
    path: "/projectrole",
    name: "Project Role",
    component: RolesSetup,
    permissionName: "VIEW_ROLE"  
  },
  {
    path: "/AddRole",
    name: "AddRole",
    component: AddNewRole,
    permissionName: "VIEW_ROLE"
  },
  {
    path: "/EditProjectRole/:id",
    name: "EditProjectRole",
    component: EditNewRole,
    permissionName: "VIEW_ROLE"
  },
  {
    path: "/projecttask",
    name: "Project Task",
    component: TaskSetup,
    permissionName: "VIEW_TASK"  
  },
  {
    path: "/AddTask",
    name: "AddTask",
    component:AddNewTask,
    permissionName: "VIEW_TASK"
  },


  {
    path: "/EditTask/:id",
    name: "EditTask",
    component:EditNewTask,
    permissionName: "VIEW_TASK"
  },
  {
    path: "/Settings",
    name: "Settings",
    component:Settings,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/Permissions",
    name: "Permissions",
    component:Permissions,
    permissionName: "VIEW_CONFIG"
  },
  {
    path: "/leaveManagement",
    name: "leaveManagement",
    component:LeaveDashboard,
    permissionName: "VIEW_LEAVE_MANAGEMENT"
  },
  {
    path: "/leaveApply",
    name: "leaveApply",
    component:LeaveApply,
    permissionName: "VIEW_LEAVE_MANAGEMENT"
  },
  {
    path: "/leaveHistory",
    name: "leaveHistory",
    component:LeaveHistory,
    permissionName: "VIEW_LEAVE_MANAGEMENT"
  },
  {
    path: "/leaveMain",
    name: "leaveMain",
    component:LeaveMain,
    permissionName: "VIEW_LEAVE_MANAGEMENT"
  },

  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    permissionName: "VIEW_REPORT"  
  },
  {
    path: "/weeklyreports",
    name: "weeeklyreports",
    component: WeeklyReport,
    permissionName: "VIEW_REPORT"  
  },
  {
    path: "/timesheetTaskTable",
    name: "timesheetTaskTable",
    component: TimesheetTaskTable,
    permissionName: "VIEW_REPORT"  
  },
  {
    path: "/timesheetSummaryView",
    name: "timesheetSummaryView",
    component: TimesheetSummaryView,
    permissionName: "VIEW_REPORT"  
  },
  {
    path: "leaveManagement/managerView",
    name: "leaveManagement",
    component: ManagerLeaveHistory,
    permissionName: "VIEW_LEAVE_MANAGEMENT"
  },


  {
    path: "/rpHomePage",
    name: "rpHomePage",
    component: RpHomePage,
    permissionName: "VIEW_RP_HOMEPAGE"
  },


  // {
  //   path: "/vraShifts",
  //   name: "vraShifts",
  //   component: VraShifts,
  //   permissionName: "VIEW_RP_HOMEPAGE"
  // },
  // {
  //   path: "/vraEdit/:id",
  //   name: "vraEdit",
  //   component: VraEdit,
  //   permissionName: "VIEW_RP_HOMEPAGE"
  // },
  // {
  //   path: "/AddVraShifts",
  //   name: "AddVraShifts",
  //   component: AddVraShifts,
  //   permissionName: "VIEW_RP_HOMEPAGE"
  // },
  {
    path: "/trainingsetup",
    name: "trainigsetup",
    component: TrainingSetup,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/addTraining",
    name: "addTraining",
    component:AddTrainee,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/importsrf",
    name: "importsrf",
    component: ImportSrf,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  
  {
    path: "/rpreports",
    name: "rpreports",
    component: RPreports,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/vraRoster",
    name: "vraRoster",
    component: VraRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/addvra",
    name: "addvra",
    component: AddVraRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/radRoster",
    name: "radRoster",
    component: RadRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/addRadRoster",
    name: "AddRadRoster",
    component: AddRadRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/vraRadAffinity",
    name: "vraRadAffinity",
    component: VraRadAffinity,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/addVraRadAffinity",
    name: "addVraRadAffinity",
    component: AddVraRadAffinity,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/qagenda",
    name: "qagenda",
    component: ImportQagenda,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/radScheduleForecast",
    name: "radScheduleForecast",
    component: RadScheduleForecast,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/radScheduleActual",
    name: "radScheduleActual",
    component: RadScheduleActual,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/radRosterReport",
    name: "radRosterReposrt",
    component: RadRosterReport,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/vraRosterReport",
    name: "vraRosterReposrt",
    component: VraRosterReport,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/radScheduleForecastCalenderView",
    name: "radScheduleForecastCalenderView",
    component: RadScheduleForecastCalenderView,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/vraSubstitutions",
    name: "vraSubstitutions",
    component: VraSubstitutions,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/vraSubstitutionEmailTemplate",
    name: "vraSubstitutionEmailTemplate",
    component: VraSubstitutionEmailTemplate,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/vraSubstitutionsHistory",
    name: "vraSubstitutionsHistory",
    component: VraSubstitutionHistory,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/vraScheduleForecastCalender",
    name: "vraScheduleForecastCalender",
    component: VraMonthlyScheduleForecastCalendar,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/vraScheduling",
    name: "vraScheduling",
    component: VraScheduling,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "Timings",
    name: "rpShiftTimingsConfig",
    component: RpShiftTimingsConfig,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/settings",
    name: "settings",
    component: Settingss,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/addAffinity",
    name: "addAffinity",
    component: AddAffinity,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/employeeInfoReport",
    name: "employeeInfoReport",
    component: EmployeeInfoReport,
    permissionName: "VIEW_REPORT"
  },
  {
    path: "/PerformanceManagement/HRview",
    name: "Performance Management",
    component: HRview,
    permissionName: "APPRAISAL_MANAGEMENT_HR"
  },
  
  {
    path: "/PerformanceManagement/ManagerView",
    name: "Performance Management",
    component: ManagerView,
    permissionName: "APPRAISAL_MANAGEMENT_MANAGER"
  },
  ///

  {
    path: "/PerformanceManagement",
    name: "Performance Management",
    component: EmployeeView,
    permissionName: "VIEW_APPRAISAL_MANAGEMENT"
  },
  {
    path: "/PerformanceManagement/ManagerView",
    name: "Performance Management",
    component: ManagerView,
    permissionName: "APPRAISAL_MANAGEMENT_HR"
  },
  ///

  {
    path: "/PerformanceManagement",
    name: "Performance Management",
    component: EmployeeView,
    permissionName: "APPRAISAL_MANAGEMENT_HR"
  },
  {
    path: "/PerformanceManagement/HRReport",
    name: "Performance Management",
    component: HRReport,
    permissionName: "APPRAISAL_MANAGEMENT_HR"
  },
  {
    path: "/PerformanceManagement/ManagerReport",
    name: "Performance Management",
    component: ManagerReport,
    permissionName: "APPRAISAL_MANAGEMENT_MANAGER"
  },
  {
    path: "/import-vra-shifts",
    name: "Import VRA Shifts",
    component: ImportVraShifts,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/ExitManagementHR",
    name: "Exit Management",
    component: ExitManagement,
    permissionName: "VIEW_CLEARANCE_HR"
  },
  {
    path: "/ExitManagement_Manager",
    name: "Exit Management",
    component: ExitManagementManager,
    permissionName: "VIEW_CLEARANCE_HR"
  },
  {
    path: "/ExitManagementManager",
    name: "Exit Management",
    component: ExitManagementManager,
    permissionName: "VIEW_CLEARANCE_MANAGER"
  },
  {
    path: "/ExitManagementManager",
    name: "Exit Management",
    component: ExitManagementManager,
    permissionName: "VIEW_CLEARANCE_MANAGER_IT"
  },
  {
    path: "/ExitManagementManager",
    name: "Exit Management",
    component: ExitManagementManager,
    permissionName: "VIEW_CLEARANCE_MANAGER_ADMIN"
  },
  {
    path: "/ExitManagementManager",
    name: "Exit Management",
    component: ExitManagementManager,
    permissionName: "VIEW_CLEARANCE_MANAGER_FINANCE"
  },
  {
    path: "/ExitManagementAdmin",
    name: "Exit Management",
    component: EMS_Admin,
    permissionName: "VIEW_CLEARANCE_ADMIN"
  },
  {
    path: "/ExitManagementIT",
    name: "Exit Management",
    component: EMS_IT,
    permissionName: "VIEW_CLEARANCE_IT"
  },
  {
    path: "/ExitManagementFinance",
    name: "Exit Management",
    component: EMS_Finance,
    permissionName: "VIEW_CLEARANCE_FINANCE"
  },
  {
    path: "/ExitManagementFinance",
    name: "Exit Management",
    component: ExitManagement_final,
    permissionName: "APPRAISAL_MANAGEMENT_HR"
  },
  {
    path: "/ImportQualityData",
    name: "ImportQualityData",
    component: ImportQualityData,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/qualityDashboard",
    name: "qualityDashboard",
    component: QualityDashboard,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/QualitySettings",
    name: "QualitySettings",
    component: QualitySettings,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/quality-details/:id",
    name: "Quality Details",
    component: QualityDetails,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/vraRadPool",
    name: "VraRadPool",
    component: VraRadPool,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/attendance",
    name: "attendance",
    component: Attendance,
    permissionName: "VIEW_TIMESHEET"  
  },
  {
    path: "/attendance/ManagerView",
    name: "attendance",
    component: AttendanceManager,
    permissionName: "VIEW_TIMESHEET"  
  },

  {
    path: "/poolPrepRoster",
    name: "poolPrepRoster",
    component: PoolPrepRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/addPoolPrepRoster",
    name: "AddPoolPrepRoster",
    component: AddPoolPrepRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/editPoolPrepRoster",
    name: "EditPoolPrepRoster",
    component: EditPoolPrepRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },

  {
    path: "/atcRoster",
    name: "atcRoster",
    component: AtcRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/addAtcRoster",
    name: "AddAtcRoster",
    component: AddAtcRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/editAtcRoster",
    name: "EditAtcRoster",
    component: EditAtcRoster,
    permissionName: "VIEW_RP_HOMEPAGE"
  },
  {
    path: "/probation-management",
    name: "Probation Management",
    component: ProbationManagement,
    permissionName: "VIEW_PROBATION_MANAGEMENT"  
  },
  
];


export default childRoutes;
